
<div class="Vert-15"></div>
<div class="container">

    <form [formGroup]="_form" >
        <div class="row">

            <div class="col-12"><h4>Property Information</h4></div>

           
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Address</mat-label>
                    <input type="text" matInput formControlName="propertyAddress">
                </mat-form-field>
      
            
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>City</mat-label>
                    <input type="text" matInput formControlName="propertyCity">
                </mat-form-field>
          
            
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>State</mat-label>
                    <input type="text" matInput formControlName="propertyState">
                </mat-form-field>
         

                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Zip</mat-label>
                    <input type="text" matInput formControlName="propertyZip">
                </mat-form-field>
            

        </div>
        <div class="row">

            <div class="col-12"><h4>Loan Information</h4></div>

           
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Closing Date</mat-label>
                    <input matInput [matDatepicker]="picker3" formControlName="closingDate">
                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                    <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>

     
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Original Loan Amount</mat-label>
                    <input type="text" matInput formControlName="totalLoanAmount">
                </mat-form-field>
      
           
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Home Value at Start of Loan</mat-label>
                    <input type="text" matInput formControlName="appraisedValue">
                </mat-form-field>


                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Interest Rate</mat-label>
                    <input type="text" matInput formControlName="interestRate">
                </mat-form-field>


                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Loan Term (months)</mat-label>
                    <input type="text" matInput formControlName="loanTerm">
                </mat-form-field>

                <mat-form-field appearance="outline" floatLabel="always" >
                    <mat-label>Loan Purpose</mat-label>
                    <mat-select formControlName="loanPurposeTypeId">
                        <mat-option *ngFor="let lp of LgvUserSvc.LoanPurposeType$ | async | sortBy:'asc':'displayOrder'" [value]="lp.id">
                            {{lp.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- <mat-form-field appearance="outline" floatLabel="always" >
                    <mat-label>Lien Type</mat-label>
                    <mat-select formControlName="lienTypeId">
                        <mat-option *ngFor="let lien of LgvUserSvc.LienType$ | async | sortBy:'asc':'displayOrder'" [value]="lien.id">
                            {{lien.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Loan Type</mat-label>
                    <mat-select formControlName="loanTypeId" [matTooltipClass]="{ 'tool-tip': true }" matTooltip=" 
                    FHA Loan: An FHA loan is insured by the Federal Housing Administration (FHA) and issued by an FHA-approved lender. FHA loans have lower minimum down payment and credit score requirements than conventional loans, but borrowers must carry mortgage insurance with payments made to the FHA.

Veterans Affairs(VA) Loan: VA loans are specifically for veterans and can offer benefits such as no- down payment options.

Conventional loans: Loans that are not guaranteed by the government and administered in the private sector.Conventional loans generally require a larger down payment but can offer greater flexibility than government loans.
                    ">
                        <mat-option *ngFor="let loan of LgvUserSvc.LoanType$ | async | sortBy:'asc':'displayOrder'" [value]="loan.id">
                            {{loan.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

        </div>
    </form>


</div>
<div class="Vert-15"></div>

